import { IConfig } from '../types/config';

// eslint-disable-next-line
export default async function (): Promise<IConfig> {
  const resp = await fetch(window.location.origin + '/config.json');
  return await resp.json();
}
